import PageOrderFeedback from '@/pages/PageOrderFeedback'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: PageOrderFeedback,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}